var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgStepTypeGroup = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 22,
  height: 22,
  viewBox: "0 0 22 22",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  x: 4,
  y: 4,
  width: 3,
  height: 3,
  rx: 1
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  x: 4,
  y: 9,
  width: 3,
  height: 3,
  rx: 1
})), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
  x: 4,
  y: 14,
  width: 3,
  height: 3,
  rx: 1
})), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
  x: 9.5,
  y: 4,
  width: 3,
  height: 3,
  rx: 1
})), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
  x: 9.5,
  y: 9,
  width: 3,
  height: 3,
  rx: 1
})), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
  x: 15,
  y: 4,
  width: 3,
  height: 3,
  rx: 1
})), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
  x: 15,
  y: 9,
  width: 3,
  height: 3,
  rx: 1
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M19 2H3C2.44772 2 2 2.44772 2 3V19C2 19.5523 2.44772 20 3 20H19C19.5523 20 20 19.5523 20 19V3C20 2.44772 19.5523 2 19 2ZM3 0C1.34315 0 0 1.34315 0 3V19C0 20.6569 1.34315 22 3 22H19C20.6569 22 22 20.6569 22 19V3C22 1.34315 20.6569 0 19 0H3Z"
})));
export default SvgStepTypeGroup;